export const USER = "/user";
export const LOGOUT = "/logout";
export const SIGNOUT = "/signout";
export const TOKEN = "/token";
export const LOGIN = "/signin";
export const LOGIN_ACCESS_CODE = "/signin_access_code";
